export function removeLeadingPostalCode(address?: string) {
  if (address === undefined) {
    return ''
  }

  return address.replace(/^\d{6},/, '').trim()
}
